module.exports = __webpack_public_path__ + "media/images/NYCHD-0b1c816e.jpg";